import { LoadingSkeleton, EmptyState, ErrorState } from './StatusIndicator'

export function ChartCard({
  title, subtitle, children, isEmpty, loading, error, height = 'h-56', headerRight,
}: {
  title: string
  subtitle?: string
  children: React.ReactNode
  isEmpty: boolean
  loading: boolean
  error?: string
  height?: string
  headerRight?: React.ReactNode
}) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6">
      <div className="flex items-start justify-between mb-1">
        <div>
          <h2 className="font-bold text-secondary">{title}</h2>
          {subtitle && <p className="text-xs text-neutral-400 mt-0.5">{subtitle}</p>}
        </div>
        {headerRight}
      </div>
      <div className="mt-4">
        {loading ? (
          <LoadingSkeleton height={height} />
        ) : error ? (
          <ErrorState message={error} />
        ) : isEmpty ? (
          <EmptyState />
        ) : (
          children
        )}
      </div>
    </div>
  )
}
